<div class="scheduler-layout">
    <div class="sidebar">

        <!-- Logo -->
        <div class="sidebar-logo">
            <h2>{{brand.brandName}} Suite</h2>
            <span>Scheduler</span>
        </div>

        <!-- Menu -->
        <ul class="sidebar-menu">

            <li>
                <a
                    class="menu-item"
                    routerLink="schedule-list"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                    <span class="material-symbols-outlined" aria-hidden="true">dashboard</span>
                    <span>All Schedules</span>
                </a>
            </li>

            <li>
                <a
                    class="menu-item"
                    routerLink="create-schedule"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ paths: 'subset', queryParams: 'ignored', fragment: 'ignored' }"
                    [featureActionState]="'SCHEDULER'"
                >
                    <span class="material-symbols-outlined" aria-hidden="true">add_circle</span>
                    <span>New Schedule</span>
                </a>
            </li>

            <li>
                <a
                    class="menu-item"
                    routerLink="schedule-history"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                    <span class="material-symbols-outlined" aria-hidden="true">history</span>
                    <span>Schedule History</span>
                </a>
            </li>

        </ul>

    </div>

    <div class="scheduler-main">
        <div class="scheduler-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
